import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const CHANGE_PASSWORD = "password/CHANGE_PASSWORD";
export const SEND_RESET_PASSWORD_EMAIL = "password/SEND_RESET_PASSWORD_EMAIL";

const CHANGE_PASSWORD_ERRORS = {
  DEFAULT: { message: strings.lib_common_state_error },
};
const SEND_RESET_PASSWORD_EMAIL_ERRORS = {
  DEFAULT: { message: strings.lib_common_state_error },
};

const initialState = {};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CHANGE_PASSWORD: {
        break;
      }

      case SEND_RESET_PASSWORD_EMAIL: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const changePassword = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_password.changePassword",
          message: strings.lib_common_state_loading,
        }
      )
    );

    const { token, uid, oldPassword, newPassword, confirmNewPassword } = values;
    const serverEndpoint =
      process.env.REACT_APP_API_SERVER_HOST +
      (token && uid
        ? process.env.REACT_APP_API_LIB_PASSWORD_RESET_PASSWORD_CONFIRM
        : process.env.REACT_APP_API_LIB_PASSWORD_CHANGE_PASSWORD);
    const requestData =
      token && uid
        ? {
            uid,
            token,
            new_password: newPassword,
            re_new_password: confirmNewPassword,
          }
        : {
            new_password: newPassword,
            re_new_password: confirmNewPassword,
            current_password: oldPassword,
          };

    axios
      .post(serverEndpoint, requestData)
      .then((response) => {
        dispatch({ type: CHANGE_PASSWORD });

        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "lib_password.changePassword" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = CHANGE_PASSWORD_ERRORS.DEFAULT;

        console.log(errorResponse);

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_password.changePassword",
                  ...error,
                },
            history
          )
        );
      });
  };
};

export const sendResetPasswordEmail = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_password.sendResetPasswordEmail",
          message: strings.lib_common_state_loading,
        }
      )
    );

    // dispatch(
    //   setAppSuccess(
    //     typeof successState === "function"
    //       ? successState({}, values)
    //       : successState ?? {
    //           context: "lib_password.sendResetPasswordEmail",
    //         },
    //     history
    //   )
    // );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_PASSWORD_SEND_RESET_PASSWORD,
        values
      )
      .then((response) => {
        dispatch({ type: SEND_RESET_PASSWORD_EMAIL });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_password.sendResetPasswordEmail",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = SEND_RESET_PASSWORD_EMAIL_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_password.sendResetPasswordEmail",
                  ...error,
                },
            history
          )
        );
      });
  };
};
